export const theme = {
  fonts: {
    body: 'Manrope, sans-serif',
    logo: 'Poppins, sans-serif',
  },
  //           0   1   2   3   4   5   6   7   8   9  10
  fontSizes: [12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 64],

  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 700,
  },

  colors: {
    accent: '#F59256',
    background: '#FDF7F2',
    buttonAccent: '#FF6101',
    black: '#111111',
    gray: 'rgba(17, 17, 17, 0.6)',
    blue: '#3091EB',
    white: '#FFFFFF',
    gradient: 'linear-gradient(90deg, #FF634E 0%, #FFDF48 105.44%)',
    primaryText: '#111111',
    secondaryText: '#F59256',
    newsText: '#111321',
    maleColor: '#23C2EF',
    femaleColor: '#FF8787',
  },

  //border-radius
  radii: {
    small: '20px',
    normal: '40px',
    round: '50%',
  },

  media: {
    mobile: '(min-width: 320px)',
    tablet: '(min-width: 768px)',
    desktop: '(min-width: 1280px)',
  },
};

// (max-width: 1279px) and
